const comment = {
  body: {
    label: "Commentaire",
    invalid: {
      assertEmpty: "Le commentaire ne doit pas être vide."
    },
  },
  hidden: {
    label: "Le commentaire est-il caché ?",
  },
  sendNotification: {
    label: "Envoyer la notification ?"
  },
  internResponsability: {
    label: "Responsabilité Nyukom ?",
    invalid: {}
  },
  forceManual: {
    label: "Forcer la facturation manuel ?",
    invalid: {}
  },
};

export default comment;
